import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

type Role = 'admin' | 'user' | 'responsable' | 'pasteur';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: Role[];
  /** Rapport spécifique requis pour les responsables (optionnel) */
  requiredReport?: string;
  /** Redirection si accès refusé (défaut : /dashboard) */
  redirectTo?: string;
}

export function ProtectedRoute({
  children,
  allowedRoles,
  requiredReport,
  redirectTo = '/dashboard',
}: ProtectedRouteProps) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  const roleAllowed = allowedRoles.includes(user.role);

  if (!roleAllowed) return <Navigate to={redirectTo} replace />;

  // Pour les responsables : vérifier l'accès au rapport spécifique
  if (user.role === 'responsable' && requiredReport) {
    const hasAccess = user.assignedReports?.includes(requiredReport) ?? false;
    if (!hasAccess) return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
